// «Якобы» brand identity — старославянский на новый лад. Craft-paper ground,
// brand ink (#221F1F) and a single vermilion accent (#ED2A23), with folk-blue
// and ochre as quiet support. Display type in Podkova (sturdy Cyrillic slab)
// with Ruslan Display for the logotype; UI text in Onest. Fonts are loaded in
// web/index.html and fall back to the system serif / sans on native.

export const colors = {
  // Warm paper neutrals — never a flat grey.
  background: '#E9E1CD',
  backgroundTop: '#EEE7D5', // slightly warmer top edge for the page vignette
  surface: '#E3D9C1', // bottom tab bar / sticky chrome
  surfaceElevated: '#DACEAF', // toggles-off, muted chips
  surfaceCard: '#F5EFE1', // cards lift off the paper
  inputBackground: '#FBF7EC',

  primary: '#ED2A23', // vermilion — the one accent
  primaryLight: '#F4564A',
  primaryDark: '#C71E17',
  onPrimary: '#F7F1E3', // paper, for text/icons on the red fill

  secondary: '#3F5C7A', // folk blue (гжель / lubok)
  danger: '#A32E22', // oxblood — destructive, kept distinct from the brand red
  warning: '#C6892F', // ochre

  textPrimary: '#221F1F', // brand ink
  textSecondary: '#5B554B',
  textMuted: '#8A8272',

  border: '#CCBF9F',
  borderStrong: '#A99A78',

  gradientStart: '#EEE7D5',
  gradientEnd: '#E9E1CD',
  redAccent: '#ED2A23',
  success: '#4B7A52', // folk green — "готово" states
};

// Paper has weight, not light. Soft warm drop shadows instead of the old neon
// halo. The keys stay (`primary` / `soft`) so call sites don't change.
export const glow = {
  primary: {
    shadowColor: '#8A2018',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.24,
    shadowRadius: 16,
    elevation: 6,
  },
  soft: {
    shadowColor: '#4A3F2A',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.12,
    shadowRadius: 18,
    elevation: 4,
  },
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const radius = {
  // Broadsheet-flavoured: tighter corners than the old neon build.
  sm: 8,
  md: 12,
  lg: 18,
  xl: 24,
  full: 999,
};

const DISPLAY = '"Podkova", "PT Serif", Georgia, "Times New Roman", serif';
const LOGO = '"Ruslan Display", "Podkova", Georgia, serif';
const UI = '"Onest", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';

export const fonts = { display: DISPLAY, logo: LOGO, ui: UI };

export const typography = {
  logo: { fontFamily: LOGO, fontSize: 24, fontWeight: '400', letterSpacing: 1 },
  h1: { fontFamily: DISPLAY, fontSize: 30, fontWeight: '800', letterSpacing: -0.2 },
  h2: { fontFamily: DISPLAY, fontSize: 22, fontWeight: '700', letterSpacing: -0.1 },
  h3: { fontFamily: DISPLAY, fontSize: 17, fontWeight: '700', letterSpacing: 0 },
  body: { fontFamily: UI, fontSize: 15, fontWeight: '400', lineHeight: 22 },
  caption: { fontFamily: UI, fontSize: 13, fontWeight: '500', lineHeight: 18 },
  button: { fontFamily: UI, fontSize: 15, fontWeight: '800', letterSpacing: 0.2 },
};

export const shadow = {
  card: glow.soft,
  button: glow.primary,
};

// Screens center their content in this width on wide screens (laptop / tablet)
// so the app stops being one endless phone-width column.
export const layout = {
  maxContentWidth: 620,
  maxWideWidth: 860,
};
